module.exports = __webpack_public_path__ + "img/icon_social1.0f7a4bae.png";